/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $('.why_wherefore_link a').click(function(e){
    var class_at = $(this).closest('body').find('.Timeline');
    e.preventDefault();
    if(class_at.length >0){
      var index = $(this).attr('data-index');
      // console.log(index,'index');
      $('.Timeline__Nav .Timeline__NavItem').each(function(){
        var index2 = $(this).attr('data-index');
        // console.log(index,'index',index2,'index2');
        if(index == index2){
          $(this).trigger('click');
        }
      });
    }else{
     var link =  $(this).attr('href');
      window.location.href = link;
    }

  });
  
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};
  
  var slide = getUrlParameter('slide');
  
  if(slide) {
  $('.why_wherefore_link a[data-index="'+slide+'"]').trigger('click');
  }
});

